/**
 * WT-28: one way to show pounds. "£1,114.10", not "£1114.10": always two
 * pence digits and a thousands separator (en-GB). Takes a number or the
 * numeric strings Postgres sends for NUMERIC columns.
 *
 * Pure, no imports, so `node --test` can load it (money.test.mjs).
 * First used by Club Admin → Sponsors and Shop; other pages still format by
 * hand and can switch over as they're touched.
 */

const GBP = new Intl.NumberFormat('en-GB', {
  style: 'currency', currency: 'GBP', minimumFractionDigits: 2, maximumFractionDigits: 2,
});

/** 1114.1 / "1114.10" → "£1,114.10". Anything that isn't a number → `fallback`. */
export const formatGBP = (value, fallback = '—') => {
  if (value === null || value === undefined || value === '') return fallback;
  const n = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(n) ? GBP.format(n) : fallback;
};
